"use client";
import { useMemo, useCallback } from "react";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import PropTypes from "prop-types";
import styles from "@/components/CustomComponents/LitertureCard/index.module.scss";
import Card from "@/components/CustomComponents/LitertureCard/Card";
import Pagination from "@/components/CustomComponents/LitertureCard/Pagination";
const ITEM_PER_PAGE = 6;

export default function LitertureCard({ CardData }) {
  const { cardItem = [], heading = "" } = CardData;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currentPage = Number(searchParams.get("page")) || 1;
  const itemsPerPage = ITEM_PER_PAGE;
  const totalPages = Math.ceil(cardItem.length / itemsPerPage);

  const currentSection = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return cardItem.slice(startIndex, startIndex + itemsPerPage);
  }, [currentPage, itemsPerPage, cardItem]);

  const handlePageChange = useCallback(
    page => {
      if (page < 1 || page > totalPages) return;
      const params = new URLSearchParams(searchParams.toString());
      params.set("page", page);
      router.replace(`${pathname}?${params.toString()}`);
    },
    [totalPages, searchParams, pathname, router]
  );

  const visiblePages = useMemo(() => {
    const pages = [];
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }, [currentPage, totalPages]);

  if (!CardData) return null;
  return (
    <div className={styles.wrapper}>
      <div className="w-full mx-auto">
        <h1 className="text-xl md:text-3xl font-bold mb-2 literature">
          {heading}
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4 items-start justify-center grid-width">
          <Card cardRows={currentSection} />
        </div>
        <Pagination
          visiblePages={visiblePages}
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
}

LitertureCard.propTypes = {
  CardData: PropTypes.object,
};

LitertureCard.defaultProps = {
  CardData: {},
};
